import React from 'react';
import { Dialog, Button, Text, useToasts } from '@applyboard/crystal-ui';
import { useDeleteCourseMapping } from '../../data/useDeleteCourseMapping';
import type { CourseMappingResource } from '@ab/ams-school-api/types/private/v1';
import { getApiErrorMessage } from '~/utils/getApiErrorMessage';

export function DeleteCourseMappingDialog(props: { courseMapping: CourseMappingResource; onClose: () => void }) {
  const { deleteCourseMapping, isDeleting } = useDeleteCourseMapping();
  const toasts = useToasts();
  const { courseMapping } = props;

  const handleDelete = React.useCallback(() => {
    deleteCourseMapping({ courseMapping })
      .then(() => {
        toasts.positive('Successfully deleted course mapping');
        props.onClose();
      })
      .catch((error) => {
        toasts.negative(
          new Error(getApiErrorMessage(error, 'Failed to delete course mapping. Please try again.'), {
            cause: error,
          })
        );
      });
  }, [deleteCourseMapping, courseMapping, toasts, props]);

  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open && !isDeleting) props.onClose();
      }}
    >
      <Dialog.Heading>Delete course mapping</Dialog.Heading>
      <Dialog.Content>
        <Text>Are you sure you want to delete this course mapping?</Text>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill" disabled={isDeleting}>
          Cancel
        </Dialog.CloseButton>
        <Button intent="negative" width="fill" onClick={handleDelete} loading={isDeleting}>
          Delete Mapping
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
}
